export default "__VITE_ASSET__Bwo$uZYk__"